import React from 'react';
import {useSelector} from 'react-redux';

import './index.scss';

//components
import DynamicLink from '../../../../components/dynamic_link';
import {getMediaPath} from "../../../../app/functions";

const HomePagePromotion = () =>{

    const images = useSelector(store => store.data.HomepageData.banners.home_page_promotions);
    const deviceState = useSelector(store => store.state.deviceState);

    const printBanners = () =>{

        const isDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';

        let res = [];

        for (let key in images){
            const item = images[key];

            res.push(
                <DynamicLink key={key} data={item.link}>
                    <img src={getMediaPath(isDesktop ? item.image : item.mobileImage)} alt=''/>
                </DynamicLink>
            );
        }

        return res;
    };

    return(
        <div className='home-promotion'>
            {printBanners()}
        </div>
    )
};

export default HomePagePromotion;